import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    padding: $theme.sizing.scale700,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: $theme.sizing.scale600
}))

export const Title = styled('h1', ({ $theme }) => ({
    ...$theme.typography.HeadingSmall,
    margin: 0,
    textAlign: 'left'
}))

export const Subtitle = styled('h1', ({ $theme }) => ({
    ...$theme.typography.LabelMedium,
    margin: 0,
    textAlign: 'left',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    gap: $theme.sizing.scale200
}))

export const Description = styled('div', ({ $theme }) => ({
    marginTop: '4px',
    fontSize: '1.4rem',
    fontWeight: 400,
    lineHeight: '2.4rem'
}))

export const DescriptionStrong = styled('strong', ({ $theme }) => ({
    fontWeight: 700
}))

export const SpinnerContainer = styled('div', () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
}))

export const InfoContainer = styled('div', ({ $theme }) => ({
    padding: '1.5rem',
    borderRadius: '1rem',
    border: `1px solid ${$theme.colors.primary}`
}))

export const BaseButtonOverride = {
    style: {
        width: '100%'
    }
}
